export const AppConstants = {
  // API paths (relative to the configured api base)
  API_PATHS: {
    GET_PORTAL_NAV_ITEMS: '/home/GetPortalNavItem',
  },
} as const;
